module.exports = __webpack_public_path__ + "img/03.a2a82a52.jpg";